module.exports = __webpack_public_path__ + "img/guava.d08326a2.png";